import { combineReducers } from 'redux';
import { type StoreState } from '../types/StoreState';
import { appStateReducer } from './appState';
import { domainReducer } from './domain';
import { requestsStateReducer } from './requestsState';
import { paymentStateReducer } from './paymentState';
import { topPropsReducer } from './topProps';
import { googlePayReducer } from './googlePay';

export const rootReducer = combineReducers<StoreState>({
  topProps: topPropsReducer,
  appState: appStateReducer,
  requestsState: requestsStateReducer,
  domain: domainReducer,
  payment: paymentStateReducer,
  googlePay: googlePayReducer,
});
